import { Error as CwbApiError } from "@amzn/client-workbench-api-model";
import { AxiosError } from "axios";
import { useMutation, UseMutationResult } from "react-query";

import { sendTempPin } from "@/apis/MidwayHelper";
import { getRetryDelayMs, shouldRetry } from "@/helpers/react-query-helper";

/**
 * Custom hook to invoke the API call to send a temp PIN to the NH's personal email through Midway.
 */
export const useSendTempPin = (): UseMutationResult<
  void,
  AxiosError<CwbApiError>
> => {
  return useMutation<void, AxiosError<CwbApiError>, unknown, unknown>(
    "sendTempPin",
    sendTempPin,
    {
      /**
       * By default, React Query will not retry a mutation on error. Only retry on Axios errors with a transient error
       * code if the failure count is within the retry limit.
       */
      retry: shouldRetry,
      retryDelay: getRetryDelayMs,
    }
  );
};
